import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import { ToasterService } from './toaster.service';


@Injectable({
    providedIn: 'root'
})
export class ExportDataService {
    dataArray: [] = [];
    constructor(
        private _toasterService: ToasterService) { }
    exportExcel(dataArray, title) {
        this.dataArray = dataArray;
        if (this.dataArray.length > 0) {
            import("xlsx").then(xlsx => {
                const worksheet = xlsx.utils.json_to_sheet(dataArray);
                const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                this.saveAsExcelFile(excelBuffer, title);
            });
        }
        else this._toasterService.toastWarning('Warning', 'Data not Exists');
    }
    saveAsExcelFile(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }
    exporttxt(buffer: any,filename:any) {
        let type = 'application/octet-stream'
        let txt_extension = '.txt';
        const data: Blob = new Blob([buffer], {
            type: type

        });
        FileSaver.saveAs(data, filename+ txt_extension);
    }
}